import { Component, Input, OnInit } from '@angular/core';

export const BENEFITS = [
  'Przypomnienia o rachunkach',
  'Płać z poziomu aplikacji',
  'Dodatkowe metody płatności',
  'Odraczanie płatności',
  'Płatności jednym kliknięciem'
];

@Component({
  selector: 'app-value-proposition',
  templateUrl: './value-proposition.component.html',
  styleUrls: ['./value-proposition.component.scss']
})
export class ValuePropositionComponent implements OnInit {
  BENEFITS = BENEFITS;
  @Input() highlight: boolean;

  constructor() {}

  ngOnInit(): void {}
}
